import React from 'react';
import Icons from './Icons';

export default function Footer() {
	return (
		<footer className="bg-slate-950 text-slate-400 py-8">
			<div className="max-w-7xl mx-auto px-4 text-center">
				<div className="font-bold text-white">MineralesPro</div>
				<div className="text-sm">© 2026 MineralesPro. Todos los derechos reservados.</div>
			</div>
		</footer>
	);
}
